<script>
  import { layoutMethods,careersMethods } from "@/state/helpers";
  import { getModuleAccess } from '@/router/helper.js'

  /**
   * Job Opening List component
   */
  export default {
    page: {
      title: "Job Opening List"
    },
    components: {
    },
    computed: {
    },
    data() {
      return {
        title: "Job Opening",
        searchValue: {
            search: null,
            searchField: null,
            page: 1,
            rows: 10,
            sort: 'id',
            orderDesc: true,
            status: null,
            job_status: null,
            department: null
        },
        searchOptions: [
          { text: 'Search All', value: null },
          { text: 'Job Title', value: "job_title" },
          { text: 'Department', value: "department" },
          { text: 'Created By', value: "created_by" },
        ],
        fields: [
          { key: "job_title", label: "Job Title", sortable: true},
          { key: "applicants", label: "Applicants", sortable: true},
          { key: "department", label: "Department", sortable: true},
          { key: "job_status", label: "Job Status", sortable: true},
          { key: "created_at", label: "Date & Time Created", sortable: true},
          { key: "reactivated_at", label: "Reactivation Date", sortable: true},
          { key: "created_by", label: "Created By", sortable: true},
        ],
        jobOpeningList: [],
        jobOpeningCount: 0,
        sortBy: "value",
        sortDesc: false,
        pageOptions: [10, 20, 30, 40, 50, 60, 70, 80, 90, 100],
        jobOpeningModule: {
          access: {
            create: true,
          }
        },
        statusList: [
          { text: 'All', value: null },
          { text: 'Active', value: 1 },
          { text: 'Inactive', value: 0 },
        ],
        jobStatusList: [
          { text: 'All', value: null },
          { text: 'Open', value: 'o' },
          { text: 'Closed', value: 'c' },
        ],
        departmentOption:[
          {"value": null,"text":"All"},
          {"value":"Human Resources","text":"Human Resources - People Culture"},
          {"value":"Finance","text":"Finance - Accounting and Finance"},
          {"value":"Business Development","text":"Business Development - Strategy and Implementation"},
          {"value":"Operations","text":"Operations - Customer Success and Branding"},
          {"value":"Product","text":"Product - Digital and Information Technology"},
          {"value":"Others","text":"Office of the CEO/Interns/Management Trainees - Others"}
        ],
      };
    },
    methods: {
      ...layoutMethods,
      ...careersMethods,
      async onSearch(state=''){
        if(state == 'reset'){
          this.searchValue.page = 1;
        }
        console.log(":: search value ::",JSON.stringify(this.searchValue));
        await this.actionCareers({
            action: "list",
            body: this.searchValue
        })
        .then((res) => {
          this.jobOpeningCount =res["message"]["pageInfo"]["total"] 
          this.jobOpeningList = res["message"]["rows"]
          console.log(res);
        }).catch((e)=>{
          console.log("error while getting list of job",e);
        });
      },
      refresh(){
       this.onSearch();
      },
      addJobOpening(){
        // alert("add Job Opening");
        this.$router.push(
          this.$route.query.redirectFrom || {
            name: "Add Job Opening", params: { id: 0}
          }
        );
      },
      tableSorting(ctx){//context
        this.searchValue.sort = ctx.sortBy;
        this.searchValue.orderDesc = ctx.sortDesc;
        this.onSearch('reset');
      },
    },
    async mounted(){
      this.changeTitle({title: 'Careers'});
      this.changeBreadCrumb({
        breadCrumbs: [
          { text: 'Peddlr', to: { name: 'Home'} },
          { text: 'Careers', to: { name: 'Job Opening'} },
          { text: 'Job Opening', to: { name: 'Job Opening'} }
        ]
      });
      await this.onSearch();

      // get the module access for checking if user has create, read, update, and/or delete access
      await getModuleAccess('Utilities', 'Careers', 'Job Opening')
        .then((access) => this.jobOpeningModule.access = access);
    }
  }
    
</script>

<template>
  <div><!-- outer div-->
      <div class="row">
          <div class="col-lg-12">
            <div class="card">
                <div class="card-body">
                    <div class="row mb-3">
                        <div class="col-md-4 col-sm-4">
                            <div class="my-2">
                                <h5 class="card-title text-dark">
                                    <span class="fw-normal ms-lg-2"> {{ jobOpeningCount }} </span> Record(s)
                                </h5>
                            </div>
                        </div>
                        <div class="col-md-8 col-sm-8">
                            <div class="d-flex justify-content-lg-end mb-lg-3">
                                <a v-if="jobOpeningModule.access.create" class="btn btn-primary me-2" @click="addJobOpening">
                                  <i class="uil uil-plus me-1"></i> Add Job Opening
                                </a>
                                <a class="btn btn-secondary"
                                  @click="refresh"
                                    ><feather
                                    type="refresh-ccw"
                                    size="16"
                                    class="icon nav-icon"
                                    ></feather
                                    >&nbsp;&nbsp; Refresh</a
                                >
                            </div>
                        </div>
                        <!-- end display rec, add job opening and refresh--> 
                        <div class="row">
                          <div class="w-auto mb-2">
                            <div class="d-flex mt-3 mb-3">
                              <div class="me-3">
                                <form class="d-flex" @submit.prevent="onSearch()">
                                  <b-form-group id="input-group-3" label-for="input-3">
                                    <b-form-select class="form-select rounded-0 rounded-start shadow-none w-200px" id="input-3" v-model="searchValue.searchField" :options="searchOptions"></b-form-select>
                                  </b-form-group>
                                  <b-form-group id="input-group-3" class="text-align-right" label-for="input-3">
                                    <template v-slot:description><div class="d-flex justify-content-end">Search for keyword</div></template>
                                    <b-form-input id="input-keyword" v-model="searchValue.search" class="rounded-0" style="width: auto"></b-form-input>
                                  </b-form-group>
                                </form>
                              </div>
                              <div class="me-3 ta-right">
                                <b-form-group label-for="transaction-status" description="Filter by Status">
                                  <b-form-select class="form-select rounded-0 rounded-start shadow-none" style="width:120px"
                                    id="transaction-status"
                                    v-model="searchValue.status"
                                    :options="statusList"
                                  ></b-form-select>
                                </b-form-group>
                              </div>
                              <div class="me-3 ta-right">
                                <b-form-group label-for="transaction-status" description="Filter by Job Status">
                                  <b-form-select class="form-select rounded-0 rounded-start shadow-none" style="width:120px"
                                    id="transaction-status"
                                    v-model="searchValue.job_status"
                                    :options="jobStatusList"
                                  ></b-form-select>
                                </b-form-group>
                              </div>
                              <div class="me-3 ta-right">
                                <b-form-group label-for="transaction-status" description="Filter by Department">
                                  <b-form-select class="form-select rounded-0 rounded-start shadow-none" style="width:160px"
                                    id="transaction-status"
                                    v-model="searchValue.department"
                                    :options="departmentOption"
                                  ></b-form-select>
                                </b-form-group>
                              </div>
                              <div class="me-3">
                                <b-form-group label="">
                                  <b-button variant="primary" type="button" @click="onSearch('reset')" class="px-2 me-2">
                                    <i class='bx bx-search bx-fw'></i>
                                    Search
                                  </b-button>
                                </b-form-group>
                              </div>
                            </div>
                          </div>
                        </div>
                        <!-- end search div--> 


                        <div class="table-responsive">
                          <div class="table align-middle table-nowrap">
                            <b-table
                              :items="jobOpeningList"
                              :fields="fields"
                              responsive="sm"
                              :current-page="searchValue.page"
                              :sort-by.sync="sortBy"
                              :sort-desc.sync="sortDesc"
                              @sort-changed="tableSorting"
                              class="table-check"
                            >
                              <template #cell(job_title)="data">
                                <span class="text-body m-0 text-capitalize">
                                  <router-link :to="{ name: 'View Job Opening', params: { id : data.item.id }}" 
                                  class="customer-name">
                                    {{ data.item.job_title}}
                                  </router-link>
                                </span>
                              </template>
                              <template #cell(applicants)="data">
                                <span class="badge bg-secondary me-1 badge-secondary p-2">{{ data.item.applicants }}</span>
                              </template>
                              <template #cell(created_at)="data">
                                {{ data.item.created_at | formatDate }}
                              </template>
                              <template #cell(reactivated_at)="data">
                                {{ data.item.reactivated_at | formatDate }}
                              </template>
                              <template #cell(created_by)="data">
                                {{ data.item.name}}
                              </template>
                              <template #cell(job_status)="data">
                                <span
                                  :class="{
                                      'text-success': data.item.job_status == 'Open',
                                      'text-danger': data.item.job_status == 'Close',
                                  }">
                                  {{ data.item.job_status}}
                                </span>
                                  <!-- {{ data.item.job_status}} -->
                              </template>
                            </b-table>
                          </div>
                        </div>
                        <div class="row g-0 text-center" v-if="jobOpeningCount == 0">
                          <span>No data to display.</span>
                        </div>
                        <div class="row" v-if="jobOpeningCount > 0">
                          <div class="col">
                            <div class="form-group row pull-left">
                              <label for="staticEmail" class="col-sm-6 col-form-label">Display:</label>
                              <div class="col-sm-6">
                                <b-form-group label-for="display-record">
                                  <b-form-select class="form-select shadow-none w-fit"
                                    id="display-record"
                                    v-model="searchValue.rows"
                                    :options="pageOptions"
                                    @change="onSearch('reset')"
                                  ></b-form-select>
                                </b-form-group>
                              </div>
                            </div>
                            <div
                              class="
                                dataTables_paginate
                                paging_simple_numbers
                                float-end
                              "
                            >
                              <b-pagination
                                v-if="jobOpeningCount != 0 && jobOpeningCount > searchValue.rows"
                                class="pagination-rounded"
                                v-model="searchValue.page"
                                :total-rows="jobOpeningCount"
                                @input="onSearch()"
                                :per-page="searchValue.rows"
                              ></b-pagination>
                            </div>
                          </div>
                        </div>

                    </div>
                    <!-- end row -->
                </div>
                <!-- end card body -->
            </div>
            <!-- end card -->
          </div><!-- end col-lg-12 -->
      </div><!-- end of row-->
  </div> <!-- end of outer div-->
</template>